import { onMounted, onUnmounted } from 'vue'

type ShortcutHandler = () => void
type ShortcutConfig = Record<string, ShortcutHandler>

export function defineShortcuts(shortcuts: ShortcutConfig) {
  const handleKeyDown = (event: KeyboardEvent) => {
    const key = event.key.toLowerCase()

    // Map common key names
    const keyMap: Record<string, string> = {
      'arrowdown': 'arrowdown',
      'arrowup': 'arrowup',
      'arrowleft': 'arrowleft',
      'arrowright': 'arrowright',
      'enter': 'enter',
      'escape': 'escape',
      'tab': 'tab',
      ' ': 'space'
    }

    const mappedKey = keyMap[key] || key

    if (shortcuts[mappedKey]) {
      event.preventDefault()
      shortcuts[mappedKey]()
    }
  }

  if (import.meta.client) {
    onMounted(() => {
      window.addEventListener('keydown', handleKeyDown)
    })

    onUnmounted(() => {
      window.removeEventListener('keydown', handleKeyDown)
    })
  }
}
